import React from "react";

function Main(props) {
    return (
        <div className="main-container">
            <h1 className="title">Quizzical</h1>
            <p className="description">Trivial questions to test your knowledge!</p>
        </div>
    );
};

export default Main;